export default "__VITE_ASSET__5c677507__"